import { render, staticRenderFns } from "./RelatorioTipoForm.vue?vue&type=template&id=0e5b8040&"
import script from "./RelatorioTipoForm.vue?vue&type=script&lang=js&"
export * from "./RelatorioTipoForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports